import { render, staticRenderFns } from "./CTotalRow.vue?vue&type=template&id=4b33585b&"
import script from "./CTotalRow.vue?vue&type=script&lang=js&"
export * from "./CTotalRow.vue?vue&type=script&lang=js&"
import style0 from "./CTotalRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports